module.exports = __webpack_public_path__ + "static/20141025_143423-a1d08d72883482040fdca7d444c0605d.jpg";